import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, apiError } from "../api";
import { useAuth } from "../auth";

export const AuthCallback = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { completeGoogleLogin } = useAuth();
    const hasProcessed = useRef(false);

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;
        const sessionId = location.hash.split("session_id=")[1]?.split("&")[0];
        if (!sessionId) {
            navigate("/login", { replace: true });
            return;
        }
        api.post("/auth/google-session", { session_id: sessionId })
            .then((r) => {
                completeGoogleLogin(r.data.token, r.data.user);
                toast.success(`Welcome to LAKOU, ${r.data.user.name || r.data.user.email}`);
                const dest = r.data.user.role === "admin" ? "/admin" : r.data.user.role === "staff" ? "/checkin" : "/";
                navigate(dest, { replace: true, state: { user: r.data.user } });
            })
            .catch((e) => {
                toast.error(apiError(e, "Google sign-in failed. Please try again."));
                navigate("/login", { replace: true });
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="min-h-screen bg-lakou-ink flex flex-col items-center justify-center gap-6" data-testid="auth-callback-loading">
            <span className="font-display font-black text-2xl tracking-[0.22em] text-goldgrad">LAKOU</span>
            <div className="w-8 h-8 rounded-full border-2 border-lakou-gold/30 border-t-lakou-gold animate-spin" />
            <p className="font-mono2 text-[10px] uppercase tracking-[0.3em] text-lakou-sand">Signing you in…</p>
        </div>
    );
};
